import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { AssetModalDesktopLayout } from "~/components/AssetModalV2/AssetModalDesktopLayout";
import { PublicInfoPanel } from "~/components/AssetModalV2/InfoPanel/PublicAssetInfoPanel";
import { TemporaryAssetModalContent, TemporaryAssetModalContentHeader, TemporaryAssetModalLeftPanel } from "~/components/AssetModalV2/TemporaryPlaceholderLayout";
export const PublicAssetModalDesktopLayout = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsx(AssetModalDesktopLayout, {
        header: /*#__PURE__*/ _jsx(TemporaryAssetModalContentHeader, {}),
        rightPanel: /*#__PURE__*/ _jsx(PublicInfoPanel, {}),
        content: /*#__PURE__*/ _jsx(TemporaryAssetModalContent, {}),
        leftPanel: /*#__PURE__*/ _jsx(TemporaryAssetModalLeftPanel, {})
    });
});
PublicAssetModalDesktopLayout.displayName = "PublicAssetModalDesktopLayout";
